import { render } from "./OptionBar.vue?vue&type=template&id=67167b59&scoped=true"
import script from "./OptionBar.vue?vue&type=script&lang=js"
export * from "./OptionBar.vue?vue&type=script&lang=js"

import "./OptionBar.vue?vue&type=style&index=0&id=67167b59&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67167b59"],['__file',"src/scripts/common/components/OptionBar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "67167b59"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('67167b59', __exports__)) {
    api.reload('67167b59', __exports__)
  }
  
  module.hot.accept("./OptionBar.vue?vue&type=template&id=67167b59&scoped=true", () => {
    api.rerender('67167b59', render)
  })

}


export default __exports__